import { render, staticRenderFns } from "./customSort.vue?vue&type=template&id=3536e78e"
import script from "./customSort.vue?vue&type=script&lang=js"
export * from "./customSort.vue?vue&type=script&lang=js"
import style0 from "./customSort.vue?vue&type=style&index=0&id=3536e78e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports